import React, { useEffect, useState } from 'react'
import { Spinner } from '../../funcs/utils';
import { getUserMaturityHistory } from '../../dashboard/user/actions';

const formatDate = (dateString) => {
    const [ years, months, days ] = dateString.split('-');
    return `${months}/${days}/${years}`;
}

const AdjustTimeHistory = ({ history, setHistory, token, username, accountIndex }) => {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchHistory = async () => {
            try {
                const response = await getUserMaturityHistory(token, username, accountIndex);
                if(response.status !== "OK") {
                    throw new Error("Something went wrong");
                }
    
                setHistory(response.payload.edits);
            } catch (error) {
                console.log(error);
            }
            finally {
                setIsLoading(false);
            }
        }
        
        fetchHistory();
    }, [])

    const tableHeaderStyle = {
        fontWeight: "bold",
        fontSize: "12px",
        padding: "8px",
        textAlign: "center",
    }

    const tableDataStyle = {
        fontSize: "12px",
        padding: "8px",
        textAlign: "center",
    }

    return (
        <div style={{ margin: "16px 0", padding: "0 16px", width: "100%", overflow: "auto", height: "256px" }}>
            <table style={{ height: "100%"}}>
                {/* Table Headers */}
                <thead>
                    <tr style={{ position: "sticky", top: 0, backgroundColor: "white" }}>
                        <th style={tableHeaderStyle}>Edited On</th>
                        <th style={tableHeaderStyle}>Maturity Years</th>
                        <th style={tableHeaderStyle}>Portfolio End Date</th>
                        <th style={tableHeaderStyle}>Edited By</th>
                    </tr>
                </thead>
                
                {isLoading && 
                    <tbody style={{ position:"relative", height: "100%"}}>
                        <tr style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)"}}>
                            <td>
                                <Spinner />
                            </td>
                        </tr>
                    </tbody>
                }

                {/* Table Body */}
                {!isLoading &&
                    <tbody>
                        {history.map((entry, index) => {
                            const { edit_date, relative_maturity_years, maturity_date, acct_type } = entry;
                            const editDate = formatDate(edit_date);
                            const maturityDate = formatDate(maturity_date);

                            return (                
                                <tr key={index}>
                                    <td style={tableDataStyle}>{editDate}</td>
                                    <td style={tableDataStyle}>{relative_maturity_years}</td>
                                    <td style={tableDataStyle}>{maturityDate}</td>
                                    <td style={tableDataStyle}>{acct_type}</td>
                                </tr>
                            )
                        })}
                    </tbody>
                }
                
                
            </table>
        </div>
    )
}

export default AdjustTimeHistory